// extracted by mini-css-extract-plugin
export var form = "_6ff5b3918f08d529848b5981bccf2bfa-css";